module.exports = __webpack_public_path__ + "media/ppc/helpful-career-advice-e7cbc05a.png";